import { createAction, props } from "@ngrx/store";
import { SettingsDataDto } from "src/app/data/dtos";

export const getSettingsData = createAction('[Settings] getSettingsData');
export const getSettingsDataSuccess = createAction(
  '[Settings] getSettingsData success',
  props<SettingsDataDto>(),
);
export const getSettingsDataSuccessAlreadyLoaded = createAction(
  '[Settings] getSettingsDataSuccessAlreadyLoaded',
  props<SettingsDataDto>(),
);
export const updateLanguageSettingsData = createAction(
  '[Settings] updateLanguageSettingsData',
  props<SettingsDataDto>(),
);

export const updateNotificationSettingsData = createAction(
  '[Settings] updateNotificationSettingsData',
  props<SettingsDataDto>(),
);

export const updateEmailsSettingsData = createAction(
  '[Settings] updateEmailsSettingsData',
  props<SettingsDataDto>(),
);
export const getSettingsDataFailure = createAction(
  '[Settings] getSettingsData failure',
  props<{ error: string }>(),
);
export const resetSettingsData = createAction('[Settings] resetSettingsData');

